import wkConfig from '../../../../widgets/axel-publication-content/js/config';

const config = wkConfig;
config.collateral.figures.graphic.renderNotes = true;

export default config;
